<template>
  <div class="d-flex" :class="boxItemClass">
    <div style="text-align: right;" :style="`${labelCustomStyle? labelCustomStyle: ''}`">
      <div class="box-item__label-wrapper">
        <SubHeader v-if="title" :color="color"  :text="title" :small="smallLabel" :componentStyle="additionalSmallHeading? 'line-height: 14px!important; height: 20px;': undefined"/> 
        <span v-if="required && showRequiredSymbol">&nbsp;*</span>
      </div>
      <template v-if="additionalSmallHeading">
        <small class="box-item__small-additional" :style="`color: ${color};`">
          {{ additionalSmallHeading }}
        </small>
      </template>
    </div>
    <template v-if="!onlyTitle">
      <template v-if="showFieldAsText">
        <span class="box-item__text" :style="`${color? 'color: '+color+';':''}`">{{ currentValue }}</span>
      </template>
      <template v-else-if="hasItems || forceSelectType">
        <v-select
          v-model="currentValue"
          :rules="rules"
          :dense="dense"
          :hint="hint"
          :persistent-hint="persistentHint"
          :error="hasError"
          :errorMessage="errorMessage"
          :style="`${customStyle}`"
          :required="required"
          :item-value="itemsValue"
          :item-text="itemsText"
          :readonly="readOnly"
          :disabled="disabled"
          :color="color"
          class="box-item__select"
          :items="items"
        />
      </template>
      <template v-else-if="isSwitchField">
        <v-switch v-model="currentValue" 
          :persistent-hint="persistentHint" :disabled="disabled" :dense="dense" :readonly="readOnly" :hint="hint"
          :style="`${customStyle}`" class="box-item__switch"></v-switch>
      </template>
      <template v-else-if="isTextAreaField">
        <v-textarea
          :outlined="outlined"
          :style="`${customStyle}`"
          :value="currentValue"
          :disabled="disabled"
          :readonly="readOnly"
          :dense="dense"
          :rows="rows"
          :color="color"
          :hint="hint"
          :persistent-hint="persistentHint"
          :row-height="rowHeight"
          :hide-details="hideDetails"
          @input="onTextareaChange"
          class="box-item__textArea"
        ></v-textarea>
        </template>
      <template v-else-if="isDateField">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="currentValue"
              style="padding-left: 12px;"
              :label="label"
              persistent-hint
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="currentValue"
            no-title
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </template>
      <template v-else>
        <v-text-field
          v-if="!isPasswordField"
          :oninput="oninput"
          :dense="dense"
          :style="`${customStyle}`"
          :type="type"
          :min="min"
          :hint="hint"
          :persistent-hint="persistentHint"
          :error="hasError"
          :errorMessages="errorMessage"
          :readonly="readOnly"
          :disabled="disabled"
          :required="required"
          :rules="rules"
          :color="color"
          v-model="currentValue"
          class="box-item__textfield"
        />
        <v-text-field
          v-else
          class="box-item__textfield"
          :oninput="oninput"
          :style="`${customStyle}`"
          :error="hasError"
          :errorMessage="errorMessage"
          :dense="dense"
          :hint="hint"
          :persistent-hint="persistentHint"
          :required="required"
          :readonly="readOnly"
          :disabled="disabled"
          :rules="rules"
          :color="color"
          v-model="currentValue"
          :type="type"
        />
      </template>
    </template>
  </div>
</template>

<script>
import SubHeader from "@/components/ui-elements/SubHeader.vue";
import {cloneDeep} from 'lodash';

export default {
  name: "ValueChainItem",
  components: {
    SubHeader,
  },
  data() {
    return {
      currentValue: "",
      dateMenu: false,
    };
  },
  props: {
    title: {
      type: String,
    },
    additionalSmallHeading:{
      type: String,
      default: ''
    },
    boxItemClass:{
      type: String,
      default: 'align-center'
    },
    showRequiredSymbol: {
      type: Boolean,
      default: false
    },
    dense:{
      type: Boolean,
      default: false
    },
    labelCustomStyle: {
      type: String
    },
    valueType:{
      type: String,
    },
    rows:{
      type: Number
    },
    rowHeight:{
      type: String,
    },
    hideDetails:{
      type: Boolean
    },
    hasError: {
      type: Boolean
    },
    errorMessage: {
      type: String,
    },
    customStyle:{
      type: String,
      default: ''
    },
    onlyTitle: {
      type: Boolean,
      default: false,
    },
    forceSelectType: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
    },
    outlined:{
      type: Boolean
    },
    itemsValue: {
      type: String,
    },
    showFieldAsText:{
      type: Boolean,
      default: false
    },
    itemsText: {
      type: String,
    },
    value: {
      type: [String, null],
    },
    color: {
      type: String,
      default: "secondary",
    },
    rules: {
      type: Array,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
    },
    persistentHint:{
      type: Boolean,
      default: false
    },
    min: {
      type: String,
    },
    oninput: {
      default: undefined,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled:{
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text",
    },
    smallLabel: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.setValue(this.value);
  },
  watch: {
    currentValue: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("updateValue", newValue);
      },
    },
    value: {
      handler(newValue){
        if(!this.showFieldAsText)
        this.setValue(newValue);
      },
      deep: true
    }
  },
  computed: {
    hasItems() {
      return this.items && this.items.length > 0;
    },
    isPasswordField() {
      return this.type === "password";
    },
    isSwitchField() {
      return this.type === "switch";
    },
    isTextAreaField(){
      return this.type === 'textarea';
    },
    isDateField(){
      return this.type === 'date'
    }
  },
  methods:{

    onTextareaChange(value){
      this.currentValue = value;

    },

    setValue(value){
      if(this.showFieldAsText && this.items && this.items.length > 0){
        let localValue = cloneDeep(value);
          if(this.valueType === 'boolean'){
            if(value === '0' || value === false || value === 'false') localValue = 0;
            if(value === '1' || value === true || value === 'true') localValue = 1;
          }
          const findElement = this.items.find(el=> {
            if(el && this.itemsValue && typeof el === 'object' && this.itemsValue in el){
              return el[this.itemsValue] === localValue;
            }
            return el === localValue;
          });
          if(findElement){
            if(this.itemsText && typeof findElement === 'object' && this.itemsText in findElement){
              this.currentValue = cloneDeep(findElement[this.itemsText]);
            }else{
              this.currentValue = cloneDeep(findElement);
            }
            return;
          }
      }
      if(this.valueType && this.valueType === 'boolean' && !this.showFieldAsText && !this.items){
        if(value === '0' || value === null || value === 0){
          this.currentValue = false;
        }else if(value === '1' || value === 1){
          this.currentValue = true;
        }else{
          this.currentValue = Boolean(cloneDeep(value));
        }
      }else{
        if(this.valueType === 'boolean' && this.items){
          if(value === '0' || value === null || value === false){
            this.currentValue = 0;
          }else if(value === '1' || value === true){
            this.currentValue = 1;
          }else{
            this.currentValue = cloneDeep(value);
          }
        }else{
          this.currentValue = cloneDeep(value);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.box-item {

  &__label-wrapper{
    display: flex;
    align-items: center;
  }

  &__select,
  &__textfield,
  &__textArea, 
  &__text {
    display: flex;
    flex:  0 0 220px;
    padding: 0;
    max-width: 100%;
    margin-left: 0.75em;
    margin-right: 1em;
    &::v-deep > * {
      padding: 4px 0 2px;
    }
  }
  &__switch {
    display: flex;
    flex:  0 0 220px;
    padding: 0;
    max-width: 100%;
    margin-left: 0.75em;
    margin-right: 1em;
    &::v-deep > * {
      padding: 0 0 2px;
    }
  }

  &__small-additional{
    float: none;
    clear: both;

  }
}


</style>
